import { render, staticRenderFns } from "./UserDetailTableTile.vue?vue&type=template&id=131f768d&scoped=true&lang=pug&"
import script from "./UserDetailTableTile.vue?vue&type=script&lang=js&"
export * from "./UserDetailTableTile.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailTableTile.vue?vue&type=style&index=0&id=131f768d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131f768d",
  null
  
)

export default component.exports